<template>
<div>

    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent fullscreen content-class="loading-dialog" class="loading-dialog">
            <v-container text-xs-center mt-5>
                <v-layout row wrap justify-center align-center justify-space-between>
                    <v-flex xs12 my-3 white--text>
                        <span class="font-weight-light display-3">Konto er spærret</span>
                    </v-flex>
                </v-layout>

            </v-container>
        </v-dialog>
    </v-layout>
</div>
</template>

<script>
export default {

    data() {
        return {
            dialog: true
        }
    },
    computed: {},
    watch: {

    }

}
</script>

<style>
.loading-dialog {
    background-color: #1976d2;
}
</style>
